import { MarkType } from "prosemirror-model";
import { Command, Transaction } from "prosemirror-state";
import { isMarkActive } from "../utils";

export function removeMark(markType: MarkType): Command {
	return (state, dispatch): boolean => {
		if (!isMarkActive(state, markType)) {
			return false;
		}

		if (dispatch) {
			const {
				from,
				to,
				empty
			} = state.selection;

			const tr: Transaction = state.tr;
			if (empty) {
				tr.removeStoredMark(markType);
				tr.scrollIntoView();
				dispatch(tr);
			} else {
				tr.removeMark(from, to, markType);
				tr.scrollIntoView();
				dispatch(tr);
			}
		}

		return true;
	};
}